import { Button, Form, Input, InputNumber } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { ErrorCode } from '../../../models/index';
import { ConfirmGroupButton } from '../../../elements/confim-group-button';

export function ErrorCodeEditPage(props: { errorCode?: ErrorCode; onSaved: (errorCode?: ErrorCode) => void; onCancel: () => void }) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.errorCode) {
      apiClient
        .post('error-codes', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`error-codes/${props.errorCode?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={props.errorCode}>
      <Form.Item
        label="Hata kodu"
        name="code"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 20, message: 'En fazla 20 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Hata tanımları"
        name="description"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 200, message: 'En fazla 200 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Birim fiyatı"
        name="unitPrice"
        rules={[
          { required: true, message: 'Zorunlu alan' },
        ]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item>
        <ConfirmGroupButton onCancel={props.onCancel} loading={loading} />
      </Form.Item>
    </Form>
  );
}
